export default __webpack_public_path__ + "static/media/manzil_mobile_carousel_2.png.webp";